import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { useFetch } from '../../hooks/useFetch';
import { pagesApi } from '../../api/pagesApi';
import { NotFound } from './NotFound';
import { SkeletonText } from '../../components/ui/Skeleton';
import { Seo } from '../../components/ui/Seo';

function extraireDescription(html, longueur = 160) {
  const texte = html?.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim() || '';
  return texte.length > longueur ? `${texte.slice(0, longueur - 1)}…` : texte;
}

/** Affiche une page créée depuis le Back Office (module "Pages CMS"), retrouvée par son slug. */
export function DynamicPage() {
  const { slug } = useParams();
  const { data: page, loading, error } = useFetch(() => pagesApi.getBySlug(slug), [slug]);

  if (loading) return <div className="prose-page"><SkeletonText lines={5} /></div>;
  if (error || !page) return <NotFound />;

  return (
    <article className="prose-page dynamic-page">
      <Seo title={page.titre} description={extraireDescription(page.contenu)} path={`/${page.slug}`} />

      <h1>{page.titre}</h1>
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(page.contenu) }} />
    </article>
  );
}
